import React, {Component} from 'react';
import {InView} from 'react-intersection-observer';

import "./circularProgressBar.scss";

class CircularProgressBar extends Component{

    constructor(props) {
        super(props);
        this.state ={
            inView: {
                visible: false
            }
        }
        this.fillProgress = this.fillProgress.bind(this);
    }

    fillProgress(inView, entry, elm){
        let updatedState;
        if(inView)
            updatedState = {...this.state.inView,[elm] : true};
        else
            updatedState = {...this.state.inView,[elm] : false};
        this.setState({inView:updatedState});
    }

    render(){

        const { radius, stroke, progress } = this.props;

        //set the exact circle radius
        const circumference = (radius - stroke * 2) * 2 * Math.PI;
        const strokeDashOffset = circumference - progress / 100 * circumference;

        //set the font to be dynamic to the outer circle
        const textFontSize = radius*0.3;
        const scoreFontSize = radius*0.7;

        return(
            <InView as = "div" className="circleContainer"
                    onChange = {(inView,entry)=>this.fillProgress(inView,entry,'visible')}
                    treshold = {1}>
                <div className='gradeContainer'>
            <svg className="svgContainer" height={radius * 2 } width={radius * 2}>
                    <circle
                        r={ (radius  - stroke * 2) > 0 ? (radius  - stroke * 2) : 0 }
                        cx={ radius }
                        cy={ radius }
                        strokeWidth={ stroke - 2  }
                        fill="transparent"
                        stroke="#f7f7f7"
                    />
                    <circle
                            className = { "fillCircleProgress" }
                            stroke="#30bac6"
                            fill="transparent"
                            strokeWidth={ stroke }
                            strokeDasharray={ circumference + ' ' + circumference }
                            strokeDashoffset={strokeDashOffset}
                            r={ (radius  - stroke * 2) > 0 ? (radius  - stroke * 2) : 0 }
                            cx={ radius }
                            cy={ radius }
                    />
            </svg>
            <div className="finalGrade">
                <span className="detailsText" style={{fontSize:textFontSize}}>ציון פיפס</span>
                <span className="score" style={{fontSize:scoreFontSize}}>{(progress/10).toFixed(1)}</span>
            </div>
                </div>
            </InView>
        )
    }
}

export default CircularProgressBar;